import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '风车动漫',
  url: 'https://zmxfkmq.cn',
  description: '风车动漫网支持在线观看全集动漫，从开头到结局连续播放，无需等待更新，满足用户一口气看完整个系列的需求。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://zmxfkmq.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <HotRecommend />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}